import { makeStyles } from "@material-ui/core/styles";

export const PdfPageStyles = makeStyles(theme => ({
  container: { maxWidth: "1280px", textDecoration: "none", marginTop: theme.spacing(3), marginBottom: theme.spacing(3), padding: theme.spacing(2) },
  button: { textDecoration: "none" },
}));
